import React from 'react';
import { Form, FormField } from '../../../shared/components/form_components/form';
import { InputForm } from '../../../shared/components/form_components/input';
import { InputSelect } from '../../../shared/components/form_components/select';
import { TiposUsuarioQuery_tiposUsuario } from '../../graphql/queries/__generated__/TiposUsuarioQuery';

interface Props {
  login?: FormLogin;
  tiposUsuario?: TiposUsuarioQuery_tiposUsuario[];
  loading?: boolean;
  onSubmit: (login: FormLogin) => void;
  onCancel?: () => void;
}

interface FormLogin {
  dsc_nome_usuario: string;
  id_tipo_usuario: number;
  senha: string;
  manter_conectado?: boolean;
}

const FormularioLogin: React.FC<Props> = (props) => {
  const fields: FormField[] = [
    {
      name: 'dsc_nome_usuario',
      label: 'Nome de usuário',
      type: 'text',
      required: true,
      component: InputForm,
    },
    {
      name: 'senha',
      label: 'Senha',
      type: 'password',
      required: true,
      component: InputForm,
    },
    {
      name: 'id_tipo_usuario',
      label: 'Tipo usuário',
      type: 'number',
      items: props.tiposUsuario?.map((t) => ({
        label: t.dsc_tipo_usuario,
        value: t.id_tipo_usuario,
      })),
      required: true,
      readOnly: true,
      component: InputSelect,
    },
  ];

  return (
    <Form
      fields={fields}
      form_name='login'
      onSubmit={props.onSubmit}
      formName='Fazer login'
      submitText='Fazer login'
      loading={props.loading}
      not_reset_on_submit
    />
  );
};

export { FormularioLogin };
export type { FormLogin };
